import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom'
import { Breadcrumb, Card } from 'antd'

import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';

import ListIstruttori from '../components/ListIstruttori';

@Wrapper({ route: 'ListaUtenti', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['ListIstruttore', 'adminPermissions'])
class ListIstruttoriRoute extends Component {

  state = {
    loading: false,
    asked: false
  }

  getBreadCrumb() {
    let breads = [
      <Breadcrumb.Item key="dash"><Link to="/dashboard">Home</Link></Breadcrumb.Item>
    ];

    breads.push(<Breadcrumb.Item key="org"><Link to={"/istruttore"}>Istruttori</Link></Breadcrumb.Item>)

    return breads;
  }

  getHeaderText() {

  }

  render() {

    return (
      <div>
        <Card
          style={{ marginBottom: '12px', backgroundColor: '#fff' }}
          bordered={false}
        >
          <h3 className="sectionTitle">Istruttori</h3>

        </Card>
        <div style={{ padding: '12px' }}>
          <Breadcrumb>
            {this.getBreadCrumb()}
          </Breadcrumb>
        </div>

        <ListIstruttori ref="listTable" {...this.props} />

      </div>
    );
  }
}

export default ListIstruttoriRoute;
